<ion-header>
    <ion-toolbar>
                <!-- {{subscription}} -->
        <ng-container *ngIf="subscription==true;else subscriptionTemplate">
            <div class="header-subscription-grid">
                <span class="material-icons">
                    mark_email_read
                </span>
                <span>Check your email to verify your account. just so know. You can only log back in once you confirm
                    your email </span>
            </div>
        </ng-container>
        <ng-template #subscriptionTemplate>
            <div class="header-sub-grid" *ngIf="freeTrialMode  && roleid !=3">
                <div class="section">
                    <span>Get Started Check Out Top Features</span>
                    <span class="material-icons">
                        keyboard_arrow_down
                    </span>
                </div>
                <div class="section">

                    <!-- <span>Days Left in Trial</span>
                    <button mat-mini-fab>
                        {{trailDaysLeft}}
                    </button> -->
                </div>
                <div class="section">
                    <button mat-raised-button class="btn-subscribe" type="submit" (click)="subscribeUser()">Subscribe
                        Now</button>
                </div>
            </div>
        </ng-template>
        <!-- <ng-container *ngIf="subscription;else subscriptionSection">
            <div class="header-sub-grid">
                <div class="section">
                    <span>Get Started Check Out Top Features</span>
                    <span class="material-icons">
                        keyboard_arrow_down
                    </span>
                </div>
                <div class="section">
                    <span>Days Left in Trial</span>
                    <button mat-mini-fab>
                        {{subscriptionDays}}
                    </button>
                </div>
                <div class="section">
                    <button mat-raised-button class="btn-subscribe" type="submit" (click)="OnHandleeSubscription()">Subsribe Now</button>
                </div>
            </div>
        </ng-container>
        <ng-template #subscriptionSection>
  
        </ng-template> -->
        <div class="header-grid" [ngClass]="getRoute()">
            <div class="menu">
                <ion-buttons slot="start">
                    <!-- <ion-icon name="more"></ion-icon> -->
                    <ion-menu-button class="btn-menu" id="head_ham_btn"></ion-menu-button>
                </ion-buttons>
            </div>

            <div class="header-img">
                <div class="header-left">
                    <div class="company-logo-sec">
                        <a href="#/baseapp/dashboard" id="head_logo" *ngIf="url=='integration'">
                            <img src="assets/images/bizdata-header-logo.svg" />
                        </a>
                        <a href="#/baseapp/dashboard" id="head_logo" *ngIf="url=='gold-finch-chat'">
                            <img src="assets/images/bizdata-header-logo.svg" />
                        </a>
                        <a href="#/baseapp/dashboard" id="head_logo" *ngIf="url=='marketplace'">
                            <img src="assets/images/bizdata-header-logo.svg" />
                        </a>
                    </div>
                    <div class="search-sec" *ngIf="hasRoute('/baseapp/marketplace')">
                        <form id="search-sec-form">
                            <div class="search-left">
                                <button mat-button [matMenuTriggerFor]="menu" id="head_search">
                                    <span class="search-label">{{defaultCategory}}</span>
                                    <span class="material-icons">arrow_drop_down</span>
                                </button>
                                <mat-menu #menu="matMenu" class="customMenu" xPosition="after" yPosition="below"
                                    [overlapTrigger]="false" [offsetY]="5">
                                    <button mat-menu-item *ngFor="let category of categories" id="head_custom_menu"
                                        value="{{category.name}}"
                                        (click)="onDropdownItemSelected(category.id,category.name,category,$event)">
                                        {{category.name}}
                                    </button>
                                </mat-menu>
                            </div>
                            <div class="search-fill">
                                <div class="search-field">
                                    <input type="text" name="searchResult" [(ngModel)]="searchResult"
                                        (ngModelChange)="getSearchOnChange($event)" id="head_search_result">
                                    <button *ngIf="searchResult" matSuffix mat-icon-button aria-label="Clear"
                                        id="head_clear_search"
                                        (click)="clearSearch()"><mat-icon>close</mat-icon></button>
                                </div>
                            </div>
                            <div class="search-right">
                                <div class="search-submit">
                                    <mat-icon id="head_search_icon" [routerLink]="['/']">search</mat-icon>
                                    <!-- <ion-icon name="search" id="head_search_icon" [routerLink]="['/']"></ion-icon> -->
                                </div>
                            </div>
                        </form>
                    </div>
                </div>
                <div class="header-right" *ngIf="url==''">
                    <div>
                        <a href="#/baseapp/dashboard" id="head_black_logo">
                            <img style="height: 46px;" src="assets/images/bizdata-header-logo.svg" />
                        </a>
                    </div>
                </div>
                <div class=" header-right" *ngIf="url=='integration'">
                    <div class="company-logo-sec">
                        <a href="#/baseapp/dashboard" id="head_black_logo">
                            <img [src]="blackHeaderLogo">
                        </a>
                    </div>
                </div>
                <div class="header-right" *ngIf="url=='gold-finch-chat' ">
                    <div class="company-logo-sec">
                        <a href="#/baseapp/dashboard" id="head_black_logo">
                            <img class="company-logo-sec" src="../../assets/images/goldfinch_ai_agent.png"
                                style="width: 320px; height: 45px;">
                        </a>
                    </div>
                </div>
            </div>

            <!-- <div *ngIf = "showguidenav" style = "position: absolute;top: 20px; right: 75px;"   matTooltip="Close Guided Navigation Forever" matTooltipPosition = "below">
              <mat-icon style="cursor: pointer;" (click) = "closeguidenav()">help</mat-icon>
            </div> -->

            <div class="settings-section" [class.free-trial]="freeTrialMode && roleid !== 3" [class]="getCartRoute()">
                <div class="cart"
                    *ngIf="hasRoute('/baseapp/marketplace') || hasRoute('/baseapp/marketplace/details/' + routeId) || hasRoute('/baseapp/marketplace/cart')">
                    <span class="cart-count" *ngIf="cartCount > 0">{{ cartCount }}</span>
                    <a href="#/baseapp/marketplace/cart">
                        <mat-icon id="head_cart_btn">shopping_cart</mat-icon>
                        <!-- <ion-icon name="cart" id="head_cart_btn"></ion-icon> -->
                    </a>
                </div>
                <div class="settings">
                    <!-- <img class="setting-icon" id="head_setting_btn" [matMenuTriggerFor]="settingsMenu" src="assets/images/settings.svg"> -->
                    <!-- <ion-icon name="settings" id="head_setting_btn"  [matMenuTriggerFor]="settingsMenu"></ion-icon> -->
                    <button class="mat-icon-btn" mat-icon-button [matMenuTriggerFor]="settingsMenu"
                        aria-label="Settings">
                        <mat-icon [matMenuTriggerFor]="settingsMenu">settings</mat-icon>
                    </button>
                </div>
            </div>
            <mat-menu #settingsMenu="matMenu" xPosition="before" [overlapTrigger]="false" [hasBackdrop]="true">
                <mat-list>
                    <mat-list-item>
                        <form [formGroup]="formGroup">
                            <mat-slide-toggle class="navtoggle" formControlName="navhelp" [checked]="showguidenav"
                                (change)=navhelp()></mat-slide-toggle>
                                <span>Navigation Help</span>
                        </form>
                    </mat-list-item>
                    <hr style="border-top: 1px solid black;">
                    <mat-list-item *ngFor="let settingItems of settingNavItems;let i=index" class="settings-menu"
                        (click)="handleClick(settingItems.lableName, settingItems.url, trigger); $event.stopPropagation()" id="head_settings_sub_btn{{i}}">
                        <mat-icon matListItemIcon class="nav-icon-right"><img
                                [src]="settingItems.icon"
                                style="width: 20px; height: 20px;" /></mat-icon>
                        <div matListItemTitle class="mat-menu-text">{{settingItems.lableName}}</div>
                    </mat-list-item>
                </mat-list>
            </mat-menu>
        </div>
            </ion-toolbar>
</ion-header>